module.exports = __webpack_public_path__ + "static/images/styles/core/components/button/images/default-bg-right.5417dabc.png";


//////////////////
// WEBPACK FOOTER
// ./styles/core/components/button/images/default-bg-right.png
// module id = 3485
// module chunks = 11